/* ============================================================
   Vintage Luxe Up — Recently Viewed
   - On PDP load: pushes the current product onto a localStorage list
     (handle, title, price, image_url, available). Capped at 8 items, deduped.
   - On any page with [data-vlu-recent]: reads the list (excluding current
     product if PDP) and renders a horizontal rail of cards.
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'vlu.recentlyViewed';
  var MAX = 8;

  function readList() {
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function writeList(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }

  function trackPdpVisit() {
    // Only track if we're on a product page. Look for the product JSON-LD or known PDP marker.
    var json = document.querySelector('script[type="application/ld+json"]');
    if (!json || !document.querySelector('main [data-product-id], main product-info')) return;

    var product;
    try {
      var data = JSON.parse(json.textContent);
      if (Array.isArray(data)) data = data[0];
      if (!data || (data['@type'] !== 'Product' && (!data['@graph'] || !data['@graph'].some(function(n){return n['@type']==='Product';})))) return;
      product = data['@type'] === 'Product' ? data : data['@graph'].find(function(n){return n['@type']==='Product';});
    } catch (e) { return; }

    if (!product || !product.url) return;

    // Get handle from URL
    var match = (product.url || window.location.pathname).match(/\/products\/([^/?#]+)/);
    if (!match) return;
    var handle = match[1];

    var vendorName = '';
    if (product.brand) {
      vendorName = typeof product.brand === 'string'
        ? product.brand
        : (product.brand.name || '');
    }
    var item = {
      handle: handle,
      title: product.name || document.title,
      vendor: vendorName,
      url: '/products/' + handle,
      image: (product.image && (Array.isArray(product.image) ? product.image[0] : product.image)) || '',
      price: (product.offers && (product.offers.price || (product.offers[0] && product.offers[0].price))) || '',
      currency: (product.offers && (product.offers.priceCurrency || (product.offers[0] && product.offers[0].priceCurrency))) || '',
      available: product.offers ? true : true,
      ts: Date.now()
    };

    var list = readList();
    list = list.filter(function (p) { return p.handle !== handle; });
    list.unshift(item);
    writeList(list);
  }

  function formatPrice(item) {
    if (!item.price) return '';
    var n = parseFloat(item.price);
    if (isNaN(n)) return item.price;
    var symbol = item.currency === 'USD' ? '$' : (item.currency === 'EUR' ? '€' : (item.currency === 'GBP' ? '£' : ''));
    return symbol + n.toFixed(0);
  }

  function renderRail() {
    var sections = document.querySelectorAll('[data-vlu-recent]');
    if (!sections.length) return;
    var list = readList();
    if (!list.length) return;

    // Exclude the product we're currently viewing (if PDP)
    var currentHandle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    if (currentHandle) list = list.filter(function (p) { return p.handle !== currentHandle; });
    if (!list.length) return;

    sections.forEach(function (section) {
      var rail = section.querySelector('[data-vlu-recent-rail]');
      if (!rail) return;
      rail.innerHTML = list.map(function (item) {
        var price = formatPrice(item);
        var safeTitle = (item.title || '').replace(/&/g, '&amp;').replace(/</g, '&lt;');
        var safeVendor = (item.vendor || '').replace(/&/g, '&amp;').replace(/</g, '&lt;');
        var imgHtml = item.image ? '<img src="' + item.image + '" alt="' + safeTitle + '" loading="lazy">' : '';
        return [
          '<a class="vlu-recent__card" href="', item.url, '">',
          '<div class="vlu-recent__media">', imgHtml, '</div>',
          '<div class="vlu-recent__info">',
          safeVendor ? '<p class="vlu-recent__vendor">' + safeVendor + '</p>' : '',
          '<h3 class="vlu-recent__title">', safeTitle, '</h3>',
          price ? '<p class="vlu-recent__price">' + price + '</p>' : '',
          '</div>',
          '</a>'
        ].join('');
      }).join('');
      section.removeAttribute('hidden');
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  ready(function () {
    trackPdpVisit();
    renderRail();
  });
})();
